export default {
    create: {
        referrals_pool: 'Create referrals',
    },
}
